/* ============================================================================
   section-fcg.js — grow-some
   Каруселька секції featured-collection-grow.liquid.

   Раніше скрипт інлайнився в секцію (дублювався на кожен екземпляр). Тепер це
   статичний asset: глобальні слухачі реєструються один раз (guard window.__fcg),
   а initFcg() безпечно ідемпотентний — кожна секція має власний прапорець
   dataset.fcgInit, тож повторні виклики нічого не ламають.
   ============================================================================ */
(function () {
  function initFcg(root) {
    root = root || document;
    root.querySelectorAll('[data-fcg-section]').forEach(function (section) {
      if (section.dataset.fcgInit === '1') return;
      section.dataset.fcgInit = '1';

      var track = section.querySelector('[data-fcg-track]');
      var prev = section.querySelector('[data-fcg-prev]');
      var next = section.querySelector('[data-fcg-next]');
      if (!track) return;

      function updateUi() {
        var scrollMax = track.scrollWidth - track.clientWidth;
        var canScroll = scrollMax > 1;
        if (prev) prev.disabled = !canScroll || track.scrollLeft <= 1;
        if (next) next.disabled = !canScroll || track.scrollLeft >= scrollMax - 1;
      }

      function step(direction) {
        var first = track.firstElementChild;
        if (!first) return;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        var amount = first.getBoundingClientRect().width + gap;
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', updateUi, { passive: true });
      window.addEventListener('resize', updateUi);

      updateUi();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(updateUi);
      }
      window.addEventListener('load', updateUi);

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(updateUi).observe(track);
      }
      track.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', updateUi, { once: true });
      });
    });
  }

  // Expose so повторні завантаження скрипта могли просто переініціалізувати.
  window.fcgInit = initFcg;

  // Глобальні слухачі — лише один раз на сторінку, навіть якщо asset підключено кілька разів.
  if (!window.__fcgGlobalBound) {
    window.__fcgGlobalBound = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initFcg(); });
    } else {
      initFcg();
    }
    document.addEventListener('shopify:section:load', function (e) { initFcg(e.target); });
  } else {
    // Скрипт виконався вдруге (інший екземпляр секції) — просто доініціалізуємо нові.
    initFcg();
  }
})();
